import {skipToken} from '@reduxjs/toolkit/query';
import {DataStatus, showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';

import {
  useGetRecordAuditDefinitionQuery,
  useUpdateRecordAuditDefinitionMutation,
} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {ApiError, useNavigate} from 'shared/web';

import {RecordAuditDefinitionForm} from '../../components/RecordAuditDefinitionForm';
import {toRecordAuditDefinitionFormValue} from '../../utils/toRecordAuditDefinitionFormValue';
import {toUpdateRecordAuditDefinitionBody} from '../../utils/toRecordAuditDefinitionRequestBody';

export function Detail() {
  const {id: definitionId} = useParams<{id: string}>();
  const navigate = useNavigate();

  const recordAuditDefinitionDetailQuery = useGetRecordAuditDefinitionQuery(
    isNil(definitionId) ? skipToken : {definitionId}
  );

  const [updateRecordAuditDefinition, updateRecordAuditDefinitionQuery] =
    useUpdateRecordAuditDefinitionMutation();

  if (isNil(definitionId)) {
    return null;
  }

  return (
    <DataStatus
      isLoading={recordAuditDefinitionDetailQuery.isLoading}
      isError={recordAuditDefinitionDetailQuery.isError}
    >
      <Show when={recordAuditDefinitionDetailQuery.data}>
        {(data) => (
          <RecordAuditDefinitionForm
            key={data.id}
            defaultValues={toRecordAuditDefinitionFormValue(data)}
            onSubmit={async (formData, setErrors, _reset, blockerContext) => {
              await updateRecordAuditDefinition({
                definitionId,
                body: toUpdateRecordAuditDefinitionBody(formData),
              })
                .unwrap()
                .then(() => {
                  showNotification.success(i18n.t('page.settings.generalChecklist.saveSuccess'));
                  if (blockerContext?.wasSubmittedFromBlocker) {
                    return;
                  }
                  navigate(settingsRoutes.recordAuditDefinition);
                })
                .catch((e: ApiError) =>
                  handleApiError(e, {
                    silentOnValidationError: true,
                    setErrors,
                    signalApiError: blockerContext?.reportApiFailure,
                  })
                );
            }}
            isLoading={updateRecordAuditDefinitionQuery.isLoading}
            isEditing
          />
        )}
      </Show>
    </DataStatus>
  );
}
